var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-dialog',{ref:"cookie_manage_log_dialog",attrs:{"controller":_vm.dialog,"close-on-click-modal":false,"dialog_title":_vm.$t('cookie_manage_dialog.title'),"append-to-body":true},on:{"close":_vm.close}},[_c('div',{staticClass:"cookie_manage_log_dialog"},[_c('div',{staticClass:"cookie_manage_log_title"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }